/**
 * Drop-in play formats per sport, with the players a side. Mirrors the
 * backend (dropInService SPORT_PLAY_FORMATS): the API refuses any other
 * format, and the first one is the default for a new session (DI-B14/B15).
 */
import { getSportConfigKey } from '../config/sportsConfig';

const RACKET = [
  { value: 'singles', label: 'Singles (1 vs 1)', size: 1 },
  { value: 'doubles', label: '👥 Doubles (2 vs 2)', size: 2 },
  { value: 'mixed', label: '👫 Mixed (2 vs 2)', size: 2 },
];

const FORMATS = {
  badminton: RACKET,
  tabletennis: RACKET,
  tennis: RACKET,
  football: [
    { value: '5v5', label: '5-a-side', size: 5 },
    { value: '7v7', label: '7-a-side', size: 7 },
    { value: '11v11', label: '11-a-side', size: 11 },
  ],
  basketball: [
    { value: '5v5', label: '5 vs 5', size: 5 },
    { value: '3x3', label: '3x3', size: 3 },
  ],
  volleyball: [
    { value: '6v6', label: '6 vs 6 (indoor)', size: 6 },
    { value: '4v4', label: '4 vs 4', size: 4 },
    { value: '2v2', label: '2 vs 2 (beach)', size: 2 },
  ],
};

/** The formats a sport's drop-ins can use ([] when the sport has none). */
export const dropInFormatsFor = (sportName) => FORMATS[getSportConfigKey(sportName)] || [];

/** { play_format, players_per_team } for a new session of this sport. */
export const defaultDropInFormat = (sportName, fallbackSize = 6) => {
  const [first] = dropInFormatsFor(sportName);
  return first
    ? { play_format: first.value, players_per_team: first.size }
    : { play_format: '', players_per_team: fallbackSize };
};

/** Players a side of a format of this sport, or null. */
export const formatSize = (sportName, format) =>
  dropInFormatsFor(sportName).find((f) => f.value === format)?.size ?? null;

/** The format of this team size, or '' when the sport has none of that size. */
export const formatForSize = (sportName, size) =>
  dropInFormatsFor(sportName).find((f) => f.size === Number(size))?.value || '';
